/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Totp_CodeInputs */

const cs_auth_totp_code = /** @type {(inputs: Auth_Totp_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód z autentikátoru`)
};

const en_auth_totp_code = /** @type {(inputs: Auth_Totp_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticator code`)
};

/**
* | output |
* | --- |
* | "Authenticator code" |
*
* @param {Auth_Totp_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_totp_code = /** @type {((inputs?: Auth_Totp_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Totp_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_totp_code(inputs)
	return cs_auth_totp_code(inputs)
});